<template>
    <v-app>
        <div>
            <v-flex >
                <div class="text-center" style="margin-top: 30px">
                    <img src="../assets/optiwatt_logo.png" style="max-width: 150px" alt="placeholder.">
                </div>
            </v-flex>
            <v-flex>
                <div class="rectangle"></div>
            </v-flex>
            <v-tabs fixed-tabs slider-color="primary">
                <v-tab to="/">
                    Leistungen
                </v-tab>
                <v-tab to="referenzen">
                    Referenzen
                </v-tab>
                <v-tab to="kontakt">
                    Kontakt
                </v-tab>
                <v-tab to="impressum">
                    Impressum
                </v-tab>
                <v-tab to="datenschutz">
                    Datenschutz
                </v-tab>
            </v-tabs>
            <router-view></router-view>
        </div>
    </v-app>
</template>

<script>
    export default {
        components: {
        },
        data() {
            return {

            };
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.rectangle {
  height: 5px;
  width: 100%;
  background-color: #112f6b;
}
</style>



// WEBPACK FOOTER //
// src/pages/container.vue